import React from 'react'
import { SidebarMenu, SidebarMenuItem, SidebarMenuProps } from '../sidebar-menu'
import { ModalWindowBody } from './components/modal-window-body'
import { ModalWindowContainer } from './components/modal-window-container'
import { ModalWindowFooter } from './components/modal-window-footer'
import { ModalWindowHeader } from './components/modal-window-header'
import { CommonModalWindowProps, ModalWindowSizeEnum } from './types'

export interface ModalWindowWithSidebarProps<
  SidebarItemId extends string | number,
> extends Omit<CommonModalWindowProps, 'children'>,
    Omit<SidebarMenuProps<SidebarItemId>, 'menuItems'> {
  menuItems: Array<
    SidebarMenuItem<SidebarItemId> & { children: () => React.ReactNode }
  >
}

export const ModalWindowWithSidebar = <SidebarItemId extends string | number>({
  isOpened = false,
  onClose,
  width = 800,
  size = ModalWindowSizeEnum.Small,
  title,
  cancelButtonProps: firstButtonProps,
  confirmButtonProps: secondButtonProps,
  hideHeader = false,
  menuItems,
  selectedItem,
  onSelect,
}: ModalWindowWithSidebarProps<SidebarItemId>) => {
  return (
    <ModalWindowContainer isOpened={isOpened} onClose={onClose} width={width}>
      <ModalWindowHeader size={size} onClose={onClose} hideHeader={hideHeader}>
        {title}
      </ModalWindowHeader>
      <div className="flex w-full">
        <div className="w-[236px] shrink-0 border-border200 border-r py-6 pr-6 pl-8">
          <SidebarMenu
            menuItems={menuItems}
            selectedItem={selectedItem}
            onSelect={onSelect}
          />
        </div>

        <div className="basis-full">
          <ModalWindowBody size={size} className="pl-5">
            {menuItems.find(item => item.id === selectedItem)?.children()}
          </ModalWindowBody>
          <ModalWindowFooter
            className="border-t-none"
            size={size}
            hideHorizontalBorder
            cancelButtonProps={firstButtonProps}
            confirmButtonProps={secondButtonProps}
          />
        </div>
      </div>
    </ModalWindowContainer>
  )
}
